//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ["list"],
  methods: {
    godetails(item) {
      if(item.url){
        window.location.href=item.url
      }else{
        this.$router.push({
          name: "popdetais",
          query: {
            id: item.id
          }
        });
      }
      
    }
  },
  filters: {
    text(msg) {
      if (msg.length <= 20) {
        return msg;
      } else {
        let str = String(msg),
          strLen = str.slice(17, 0);
        return str.replace(strLen, "...");
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/Dlist.vue